import { Component, OnInit, Input, Optional, Self, ElementRef, Output, EventEmitter, forwardRef } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';

import { Observable } from 'rxjs/internal/Observable';


@Component({
  selector: 'intelli-selector',
  templateUrl: './intelli-selector.component.html',
  styleUrls: ['./intelli-selector.component.css'],
  providers: [

    { provide: MatFormFieldControl, useExisting: IntelliSelectorComponent },
 
  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class IntelliSelectorComponent implements MatFormFieldControl<number>, ControlValueAccessor {


  @Output() change: EventEmitter<number | null> = new EventEmitter();
  
  @Input()
  public options: any[] = [];

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'intelli-selector';
  id = `intelli-selector-${IntelliSelectorComponent.nextId++}`;
  describedBy = '';


  private onChangeValue: (value: number) => void;


  writeValue(obj: number): void {
    this.value = obj;
  }
  registerOnChange(onChange: (value: number) => void): void {


    console.log("Registrandoooo")
    this.onChangeValue = onChange;

    this.InitializeAutocompleteControls();
  }
  registerOnTouched(fn: any): void {
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("selectedId").disable();
    }
    else {
      this.parts.get("selectedId").enable();
    }
  }


  get empty() {
    const { value: { selectedId } } = this.parts;


    return selectedId == null;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);

    if (this._disabled)
      this.parts.get("selectedId").disable()
    else
      this.parts.get("selectedId").enable()

    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): number | null {

    return this.parts.get("selectedId").value;

  }

  set value(value: number | null) {

    value = value || 0;
    this.parts.get("selectedId").setValue(value);

    this.stateChanges.next();
  }

  constructor(@Optional() @Self() public ngControl: NgControl,
    fb: UntypedFormBuilder, private fm: FocusMonitor,
    private elRef: ElementRef<HTMLElement>
    // ,
    // private customerService: CustomersService
  
  ) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      selectedId: 0
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });


    // this.InitializeAutocompleteControls();
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {

  }


  displayVendorFn(vendor?: any): string | undefined {

    return vendor ? vendor.Name : undefined;
  }

  public InitializeAutocompleteControls(): void {

    this.parts.get("selectedId").valueChanges
      .subscribe(data => {

        this.onChangeValue(this.value);

      })


  }


  public compareFn: ((f1: any, f2: any) => boolean) | null = this.compareByValue;

  compareByValue(f1: any, f2: any) {

    return f1 === f2;
  }


  fireChange()
  {
console.log("this.value")
    console.log(this.value)

this.change.emit(this.value);
  }

}